<template>
  <div class="col-12">
    <Search
      :allowFields="$lang.ticketLang && $lang.ticketLang.allTicketUsersSearch"
      :allowCollapse="false"
      :url="url"
      :title="$lang.ticketLang && $lang.ticketLang.ticket_list_user"
      addModalSize="xl"
      removeModalSize="xl"
      :visibleSearch="true"
      :visibleSettings="true"
      :visibleExport="true"
      :visibleFilters="true"
      :visibleViewCount="true"
      :visibleAdd="false"
      :allowEdit="false"
      :dynamicButtons="availableButtons"
      ref="allTicketUsersSearch"
      :filterCatch="true"
    />
  </div>
</template>

<script>
import Search from "@/components/base/search";

export default {
  components: {
    Search,
  },
  data() {
    return {
      url: this.$config.api_url + this.$config.ticket.all_ticket_users,
      availableButtons: [
        {
          id: "0",
          name: "editView",
          click: this.editUserTicket,
        },
        {
          id: "1",
          name: "view",
          click: this.editUserTicket,
        },
      ],
    };
  },
  methods: {
    editUserTicket(item) {
      let routeData = this.$router.resolve({
        name: "all_ticket_search",
        query: {
          user_code: item.code,
        },
      });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>

